// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKING!
export const VERSION = {
    "dirty": false,
    "raw": "v1.0.12-0-gfb2e33f6",
    "hash": "gfb2e33f6",
    "distance": 0,
    "tag": "v1.0.12",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.0.12",
        "major": 1,
        "minor": 0,
        "patch": 12,
        "prerelease": [],
        "build": [],
        "version": "1.0.12"
    },
    "suffix": "0-gfb2e33f6",
    "semverString": "1.0.12",
    "version": "1.0.12",
    "versionDateTime": "2026-10-21T13:37:34.364Z"
};
